<template>
  <div>
    <generic-container
      :title="$t('active support plans')"
      icon="file contract"
      :searchable="true"
      :show_plus="true"
      v-on:add="add"
      v-on:filter="filter"
      :header_buttons="header_buttons"
    >
      <div class="ui two cards">
        <div
          class="card"
          v-for="(service, index) in support_services"
          :key="index"
        >
          <div class="content">
            <img
              class="right floated mini ui image"
              src="/images/icons/online_support.png"
            />
            <div class="header">{{ service.name }}</div>
            <div class="meta">
              <a @click="goto_customer(service.ctm_customer)">{{
                service.ctm_customer
                  ? service.ctm_customer.name
                  : $t("anonymous")
              }}</a>
              <small>| {{ service.create_date | formatDate }}</small>
            </div>
            <div class="description">
              <div class="ui left floated statistic">
                <div class="value">{{ service.support_hours }}</div>
                <div class="label">{{ $t("support hours") }}</div>
              </div>
              <div class="ui right floated statistic">
                <div class="value">{{ elapsed_time(service) }}</div>
                <div class="label">{{ $t("elapsed hours") }}</div>
              </div>
            </div>
            <div class="description">
              <p>{{ service.description }}</p>
            </div>
          </div>
          <div class="extra content">
            <div
              class="ui indicating progress"
              ref="progress"
              :data-percent="percentage(service)"
            >
              <div class="bar"></div>
              <div class="label">{{ percentage(service) }}%</div>
            </div>
          </div>
          <div class="ui bottom attached basic buttons">
            <div
              class="ui button"
              v-on:click="register_support(service, index)"
            >
              <i class="bug icon"></i>
              {{ $t("register") }}
            </div>
            <div class="ui button" v-on:click="view_support(service, index)">
              <i class="task list icon"></i>
              {{ $t("list") }}
            </div>
            <div class="ui button" v-on:click="edit_service(service, index)">
              <i class="edit icon"></i>
              {{ $t("edit") }}
            </div>
            <div class="ui button" v-on:click="send_mail(service)">
              <i class="send icon"></i>
              {{ $t("send") }}
            </div>
          </div>
        </div>
      </div>
    </generic-container>
    <template v-for="(mdl, index) in service_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:destroy="destroy"
        v-on:succedded="succedded"
        :service_in="selected_service"
      ></component>
    </template>
    <template v-for="(mdl, index) in support_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:destroy="destroy"
        v-on:succedded="succedded_support"
        :service_in="selected_service"
      ></component>
    </template>
    <template v-for="(mdl, index) in support_list_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:destroy="destroy"
        :service_in="selected_service"
      ></component>
    </template>
    <template v-for="(mdl, index) in send_mail_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:destroy="destroy"
        :service_in="selected_service"
      ></component>
    </template>
  </div>
</template>

<script>
import { local_api } from "@/utils";
import { cloneDeep } from "lodash";
// import { v4 } from "uuid";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
// import ConfigureModal from "./ConfigureModal";
import ServiceModal from "./SupportControlServiceModal";
import SupportModal from "./SupportControlSupportModal";
import SupportListModal from "./SupportControlSupportListModal";
import SendMailModal from "./SupportControlSendMailModal";

// @ is an alias to /src
export default {
  name: "SupportControlIndex",
  components: {
    "generic-container": GenericContainer,
  },
  filters: filters,
  data() {
    return {
      support_services: [],
      all_services: [],
      service_modals: [],
      support_modals: [],
      support_list_modals: [],
      send_mail_modals: [],
      selected_service: undefined,
      header_buttons: [
        {
          icon: "refresh",
          color: "green",
          click: this.refresh,
          tooltip: this.$t("refresh"),
        },
      ],
    };
  },
  methods: {
    add() {
      this.service_modals.push(ServiceModal);
    },
    succedded(service) {
      let trgtIdx = this.support_services.findIndex(
        (n) => n.uuid == service.uuid,
      );
      if (trgtIdx == -1) {
        this.support_services.push(service);
      } else {
        this.support_services.splice(trgtIdx, 1, service);
      }
      this.destroy();
    },
    succedded_support(support, service) {
      if (service) service.sup_supports.push(support);
    },
    destroy() {
      this.service_modals = [];
      this.support_modals = [];
      this.send_mail_modals = [];
      this.selected_service = undefined;
      this.refresh();
    },
    filter(filter) {
      // console.log(filter);
      if (filter == "") this.service_modals = cloneDeep(this.all_services);
      else
        this.support_services = this.all_services.filter((n) =>
          n.name.toUpperCase().includes(filter.toUpperCase()),
        );
    },
    edit_service(service) {
      this.selected_service = service;
      this.service_modals.push(ServiceModal);
    },
    elapsed_time(service) {
      if (!service) return 0;
      let tm = service.sup_supports.reduce((prev, curr) => {
        return prev + Number(curr.elapsed_hours);
      }, 0);
      return tm;
    },
    percentage(service) {
      let tm = this.elapsed_time(service);

      let prcnt = ((tm / service.support_hours) * 100).toFixed();

      return prcnt;
    },
    goto_customer(customer) {
      if (customer) {
        this.$router.push({
          name: "CustomerView",
          query: { i: customer.uuid },
        });
      }
    },
    refresh() {
      let vm = this;
      local_api(vm, "post", "/support_control/do-get-all")
        .then((plans) => {
          // plans = plans.map(p => {
          //   let elapsed = 0;
          //   if (p.sup_supports) {
          //     let r = p.sup_supports.reduce(function(prev, curr, idx, arr) {
          //       console.log(prev, curr, idx, arr);
          //     }, 0);
          //     elapsed = r;
          //   }
          //   p.elapsed = elapsed;
          //   return p;
          // });

          vm.support_services = plans;
          vm.all_services = cloneDeep(plans);

          setTimeout(() => {
            window.jQuery(vm.$refs.progress).progress();
          }, 200);
        })
        .catch((err) => {
          vm.$alertify.error(JSON.stringify(err, null, 2));
        });
    },
    register_support(service) {
      this.selected_service = service;
      this.support_modals.push(SupportModal);
    },
    view_support(service) {
      this.selected_service = service;
      this.support_list_modals.push(SupportListModal);
    },
    send_mail(service) {
      // this.$router.push({
      //   name: "SupportControlExternalView",
      //   query: { i: service.uuid, c: v4() }
      // });
      this.selected_service = service;
      this.send_mail_modals.push(SendMailModal);
    },
  },
  mounted() {
    this.refresh();
  },
  watch: {},
};
</script>
